import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { ComingSoon } from '@components/dashboard/components/ComingSoon';
import { H5, H6 } from '@components/dashboard/Typography';
import { VMS_NORMAL_TICK_IMG } from '@constants';
import Card from './Card';
import { SFDBodyMDSFMBodyLG, SFMBodyMD } from './Typography';

interface Props {
  title?: string;
  info?: string;
  background?: string;
  image?: string;
  symptoms?: string[];
  comingSoon?: boolean;
}

const ScreeningParametersInfoMobileItem = ({ background, image, title, info, symptoms, comingSoon }: Props) => {
  const { t } = useTranslation();

  return (
    <ItemWrapper>
      <Card
        backgroundColor={background}
        contentBackgroundColor={background}
        borderRadius={'5px'}
        expandable={true}
        cardOpen={false}
        noGap
        leading={
          <ItemHeadWrapper>
            <LazyLoadImage src={image} alt={title} />
            <ItemTitleWrapper>
              <H5>{title}</H5>
              {comingSoon && <ComingSoon>{t('components.coming-soon')}</ComingSoon>}
            </ItemTitleWrapper>
          </ItemHeadWrapper>
        }
        content={
          <ItemContentWrapper>
            <SFDBodyMDSFMBodyLG>{info}</SFDBodyMDSFMBodyLG>
            <ItemSymptomsWrapper>
              <H6>{t('symptom.what-are')}</H6>
              {symptoms?.map((symptom) => (
                <ItemSymptom key={`spis-item-${symptom}`}>
                  <LazyLoadImage src={VMS_NORMAL_TICK_IMG} alt={'normal tick'} />
                  <SFMBodyMD>{symptom}</SFMBodyMD>
                </ItemSymptom>
              ))}
            </ItemSymptomsWrapper>
          </ItemContentWrapper>
        }
      />
    </ItemWrapper>
  );
};

export default ScreeningParametersInfoMobileItem;

const ItemWrapper = styled.div`
  display: flex;
  margin-right: 40px;
  width: 100%;

  .card-content-wrapper {
    padding: 0 !important;
  }

  @media (max-width: 768px) {
    margin-right: 0;
    max-width: 100%;
  }
`;

const ItemHeadWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  h5 {
    text-transform: uppercase;
  }
`;

const ItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
  justify-content: flex-start;
`;

const ItemContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const ItemSymptomsWrapper = styled.div`
  h6 {
    padding-top: 20px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
`;

const ItemSymptom = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
